<section class="progress-bar-mobile" *ngIf="showHeader">
  <div class="progress-buttons" (click)="goPrevious()">
    <span class="prev-icon" [ngClass]="{ enabled: previousEnabled }"> </span>
    <p
      class="prev-text relative"
      [ngStyle]="styleProgressBtns('prev')"
      [ngClass]="{ enabled: previousEnabled }"
      >Back</p
    >
  </div>
  <div class="progress-bar">
    <p class="question-number">
      Question: {{ currentQuestion }}/{{ totalQuestions }}
    </p>
    <!-- <p class="question-number">sample Question</p> -->
    <div class="progress-bar-items">
      <span
        *ngFor="let question of questions; let questionIndex = index"
        class="bar"
        [ngClass]="{
          progress: question.progress,
          attended: question.attended,
          error: question.error
        }"
      >
      </span>
    </div>
  </div>
  <div class="progress-buttons" (click)="goNext()">
    <p
      class="pr-2 next-text relative"
      [ngStyle]="styleProgressBtns('next')"
      [ngClass]="{ enabled: nextEnabled }"
      >Next</p
    >
    <span class="next-icon" [ngClass]="{ enabled: nextEnabled }"></span>
  </div>
</section>
